@if (content) {
<div class="pos-relative p-a p-t-14 p-b-14 bg-col-w center">
    <button class="pos-absolute z-2 top-2 right-2 p-a-2"
            role="button"
            aria-label="Close"
            (click)="close()">
        <i class="icon-close"
           aria-hidden="true"></i>
    </button>

    @if (content.title) {
    <h2 class="o1"
        *iCms="'title' of content"></h2>
    } @else {
    <h2 class="o1">{{'Please add products to your basket to redeem this reward' | translate}}</h2>
    }

    @if (content.subtitle) {
    <h4 class="h4 m-t-2 col-11"
        *iCms="'subtitle' of content; skipEmpty: true"></h4>
    }
</div>
}
